import { render, staticRenderFns } from "./WordPage.vue?vue&type=template&id=69394bba"
import script from "./WordPage.vue?vue&type=script&lang=js"
export * from "./WordPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports